export default __webpack_public_path__ + "static/media/network.ba14474e.svg";